import { LazyImport, LazyModule } from 'owa-bundling';
import { lazyImportWithErrorHandler } from 'mini-error-handler/lib/utils/lazyImportWithErrorHandler';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "JunkEmailConfiguration" */ './lazyIndex')
);

// Lazy Actions
export const lazyInitMailboxJunkEmailConfiguration = lazyImportWithErrorHandler(
    new LazyImport(lazyModule, m => m.initMailboxJunkEmailConfiguration)
);
